export default "__VITE_ASSET__Df5t4AZH__"